<template>
    <div class=""></div>
</template>

<script>
import { eventBus } from '../eventBus'

export default {
    props: {
        disableNotify: {
            type: Boolean,
            default: false
        },
        disablePageLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // Store handlers for cleanup
            _eventHandlers: []
        };
    },
    beforeUnmount() {
        // Cleanup: remove all event listeners when component is destroyed
        this._eventHandlers.forEach(({ event, handler }) => {
            eventBus.off(event, handler)
        })
    },
    methods: {
        // Page Loading methods
        onPageLoading(callback = ({ showLoading, message }) => {}) {
            if (this.disablePageLoading) {
                return false;
            }

            const handler = ({ showLoading, message }) => callback(showLoading, message);
            eventBus.on('pageLoading', handler);
            this._eventHandlers.push({ event: 'pageLoading', handler });
        },
        triggerPageLoading(showLoading, message = '') {
            if (this.disablePageLoading) {
                return false;
            }

            eventBus.emit('pageLoading', { showLoading, message });
        },

        // Notification methods
        onNotify(callback = () => {}) {
            if (this.disableNotify) {
                return false;
            }

            eventBus.on('notify', callback);
            this._eventHandlers.push({ event: 'notify', handler: callback });
        },
        onNotifyBy(type = 'success', callback = () => {}) {
            if (this.disableNotify) {
                return false;
            }

            this.onNotify((payload) => {
                if (payload.type === type) {
                    callback(payload);
                }
            });
        },
        notifyBy(type = 'success', payload) {
            if (this.disableNotify) {
                return false;
            }

            eventBus.emit('notify', {
                ...payload,
                type
            });
        },
    }
}
</script>
